import { SCAN_RACK_COMP } from './../inventory/scan-rack/edit/edit.const';
import { API_CALL_ERROR } from './../../store/action';
import { ApiService } from './../../api/api.service';
import { AppInjector } from './../../app-injector';
import { fork, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'lodash';

import listSaga from './list/list.saga';
import createSaga from './create/create.saga';
import editSaga from './edit/edit.saga';
import { FETCH_ALL_LOCATIONS_REQUESTED, FETCH_ALL_LOCATIONS_SUCCEEDED, GET_LOCATION_REQUESTED, GET_LOCATION_SUCCEEDED } from './location.actions';
import { FETCH_ALL_LOCATIONS, FETCH_CURRENT_LOCATION } from '../inventory/scan-rack/edit/edit.actions';

function* getListLocations(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.location.list().toPromise();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case SCAN_RACK_COMP:
          yield put({ type: FETCH_ALL_LOCATIONS, data: results });
          break;

        default:
          break;
      }
    } else {
      yield put({ type: FETCH_ALL_LOCATIONS_SUCCEEDED, data: results });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchListLocationsRequest() {
  yield takeEvery(FETCH_ALL_LOCATIONS_REQUESTED, getListLocations);
}

function* getLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.location.getItemById(action.data).toPromise();

    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case SCAN_RACK_COMP:
          yield put({ type: FETCH_CURRENT_LOCATION, data: result });
          break;

        default:
          break;
      }
    } else {
      yield put({ type: GET_LOCATION_SUCCEEDED, data: result });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetLocationRequest() {
  yield takeEvery(GET_LOCATION_REQUESTED, getLocation);
}

export default _.map([...listSaga, ...createSaga, ...editSaga, watchFetchListLocationsRequest, watchGetLocationRequest], item => fork(item));
